export default class Lightbox {
  constructor(element) {
    this.element = element;
    this.items = [...this.element.querySelectorAll('[data-lightbox-item]')];
    this.currentIndex = 0;

    if (!this.items.length) {
      return;
    }

    this.close = this.close.bind(this);
    this.onKeydown = this.onKeydown.bind(this);
    this.init();
  }

  init() {
    this.items.forEach((item, index) => {
      item.addEventListener('click', (event) => {
        event.preventDefault();
        this.open(item);
      });
    });
  }

  open(selectedItem) {
    this.activeItems = this.getActiveItems();
    this.currentIndex = this.activeItems.indexOf(selectedItem);

    if (this.currentIndex === -1) {
      this.currentIndex = 0;
    }

    this.create();
    this.render();
    document.body.appendChild(this.lightbox);
    document.documentElement.classList.add('lightbox-is-active');
    document.addEventListener('keyup', this.onKeydown);
  }

  create() {
    this.lightbox = document.createElement('div');
    this.lightbox.className = 'lightbox';
    this.lightbox.setAttribute('role', 'dialog');
    this.lightbox.setAttribute('aria-modal', 'true');
    this.lightbox.setAttribute('aria-labelledby', 'lightbox-title');

    this.lightbox.innerHTML = `
      <button class="lightbox__scrim" type="button" data-lightbox-close aria-label="Fermer"></button>
      <div class="lightbox__dialog">
        <button class="lightbox__close" type="button" data-lightbox-close aria-label="Fermer"></button>
        <button class="lightbox__nav lightbox__nav--prev" type="button" data-lightbox-prev aria-label="Image precedente"></button>
        <figure class="lightbox__figure">
          <img class="lightbox__image" src="" alt="">
          <figcaption class="lightbox__caption">
            <p id="lightbox-title" class="lightbox__title"></p>
            <p class="lightbox__description"></p>
          </figcaption>
        </figure>
        <button class="lightbox__nav lightbox__nav--next" type="button" data-lightbox-next aria-label="Image suivante"></button>
      </div>
    `;

    this.lightbox.querySelectorAll('[data-lightbox-close]').forEach((button) => {
      button.addEventListener('click', this.close);
    });

    this.lightbox.querySelector('[data-lightbox-prev]').addEventListener('click', () => this.goTo(this.currentIndex - 1));
    this.lightbox.querySelector('[data-lightbox-next]').addEventListener('click', () => this.goTo(this.currentIndex + 1));
  }

  render() {
    const item = this.activeItems[this.currentIndex];
    const image = this.lightbox.querySelector('.lightbox__image');
    const title = this.lightbox.querySelector('.lightbox__title');
    const description = this.lightbox.querySelector('.lightbox__description');

    image.src = item.getAttribute('href');
    image.alt = item.dataset.lightboxAlt || item.querySelector('img')?.alt || '';
    title.textContent = item.dataset.lightboxTitle || '';
    description.textContent = item.dataset.lightboxDescription || '';
  }

  goTo(index) {
    if (index < 0) {
      this.currentIndex = this.activeItems.length - 1;
    } else if (index >= this.activeItems.length) {
      this.currentIndex = 0;
    } else {
      this.currentIndex = index;
    }

    this.render();
  }

  getActiveItems() {
    return this.items.filter((item) => !item.closest('[hidden]') && !item.closest('.is-hidden'));
  }

  onKeydown(event) {
    if (event.key === 'Escape') {
      this.close();
    }

    if (event.key === 'ArrowLeft') {
      this.goTo(this.currentIndex - 1);
    }

    if (event.key === 'ArrowRight') {
      this.goTo(this.currentIndex + 1);
    }
  }

  close() {
    document.documentElement.classList.remove('lightbox-is-active');
    document.removeEventListener('keyup', this.onKeydown);

    if (this.lightbox && this.lightbox.parentElement) {
      this.lightbox.parentElement.removeChild(this.lightbox);
    }
  }
}
